<div class="base-header d-md-none" [class.header--compact]="compact" [class.header--tabs-follow]="tabsFollow">
  <h2>
    <span class="title">{{ header | translate: params }}</span>
  </h2>
  @if (contextInfo) {
    <p class="title-context-info">{{ contextInfo }}</p>
  }
  <div class="header-buttons">
    <div class="main-buttons">
      @if (helpButtonsVisible) {
        <ul class="mform-menu w-100">
          @if (menuDefinition) {
            <li>
              <app-context-menu class="form-action" [menuDefinition]="menuDefinition" [alwaysVisible]="true" [leftSide]="true"></app-context-menu>
            </li>
          }
          @if (saveVisible) {
            <li>
              <button data-testid="form-save" class="btn btn-primary btn-sm" type="button" (click)="saveClicked()" [disabled]="isSaveDisabled">
                <img src="assets/icons/save.svg" alt="save" />{{ 'SAVE_BTN' | translate }}
              </button>
            </li>
          }
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          <li [style.visibility]="cancelVisible ? 'visible' : 'hidden'">
            <button class="btn link-btn btn-sm" type="button" (click)="cancelClicked()">
              <img src="assets/icons/list.svg" alt="view list" />{{ cancelText | translate }}
            </button>
          </li>
        </ul>
      }
    </div>
    @if (hasQuickAccessInfo) {
      <div class="side-buttons">
        <button class="btn link-btn btn-sm btn-arrow" type="button" (click)="toggleShowInfo()">
          <img src="assets/icons/arrow-top.svg" [class.rotated]="showInfo" />
        </button>
      </div>
    }
  </div>
  @if (hasQuickAccessInfo) {
    <div [class.show]="showInfo" class="info-dropdown">
      <table class="quick-access-table">
        @for (item of quickAccessItems; track item) {
          <tr>
            <td class="field">{{ item.field | translate }}</td>
            <td class="value">{{ item.value }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
<!-- desktop -->
<div class="header d-none d-md-block" [class.header--compact]="compact" [class.header--tabs-follow]="tabsFollow">
  <div class="d-inline-block v-align-middle title-block">
    <h1>{{ header | translate: params }}</h1>
    @if (contextInfo) {
      <p>{{ contextInfo }}</p>
    }
  </div>
  @if (menuDefinition) {
    <app-context-menu
      class="form-action"
      [menuDefinition]="menuDefinition"
      [alwaysVisible]="true"
      [leftSide]="true"
    ></app-context-menu>
  }
  <ul class="form-menu v-align-middle">
    @if (saveVisible) {
      <li>
        <button data-testid="form-save" class="btn btn-primary" type="button" (click)="saveClicked()" [disabled]="isSaveDisabled">
          <img src="assets/icons/save.svg" alt="save" />{{ 'SAVE_BTN' | translate }}
        </button>
      </li>
    }
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    @if (cancelVisible) {
      <li>
        <button class="btn link-btn" type="button" (click)="cancelClicked()">
          <img src="assets/icons/list.svg" alt="view list" />{{ cancelText | translate }}
        </button>
      </li>
    }
    @if (hasQuickAccessInfo) {
      <li>
        <button class="btn link-btn btn-arrow" type="button" (click)="toggleShowInfo()">
          <img src="assets/icons/arrow-top.svg" [class.rotated]="showInfo" />
        </button>
      </li>
    }
  </ul>
  @if (hasQuickAccessInfo) {
    <div [class.show]="showInfo" class="info-dropdown">
      <table class="quick-access-table">
        @for (item of quickAccessItems; track item) {
          <tr>
            <td class="field">{{ item.field | translate }}</td>
            <td class="value">{{ item.value }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
